import { LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';

import { CicReasonStatusEnum } from 'constants/status';

export const CicStatusConfig = {
  [CicReasonStatusEnum.PENDING]: {
    variant: LabelVariant.ORANGE,
  },
  [CicReasonStatusEnum.SAVED]: {
    variant: LabelVariant.ORANGE,
  },
  [CicReasonStatusEnum.DISCLOSED]: {
    variant: LabelVariant.GRAY,
  },
  [CicReasonStatusEnum.DELETED]: {
    variant: LabelVariant.RED,
  },
};
